let _confettiPromise = null;
function getConfetti() {
  if (!_confettiPromise) _confettiPromise = import('canvas-confetti').then(m => m.default);
  return _confettiPromise;
}

export async function playCompletionAnimation(element) {
  if (!element) return;
  const rect = element.getBoundingClientRect();
  const x = (rect.left + rect.width / 2) / window.innerWidth;
  const y = (rect.top + rect.height / 2) / window.innerHeight;
  try {
    const confetti = await getConfetti();
    confetti({
      particleCount: 35,
      spread: 70,
      origin: { x, y },
      colors: ['#EAB308', '#FDE047', '#FEF3C7', '#FACC15', '#F59E0B'],
      ticks: 50,
      gravity: 1.8,
      scalar: 0.8,
      shapes: ['circle', 'square'],
    });
  } catch (e) {
    console.warn('Confetti failed:', e.message);
  }
}

let cachedAudio = null;

// 투두둑 (tudu-duk, the Korean sound of acorns dropping): three acorns on wood
// with a couple of rebounds each, then rolling off — about 1.15s. Synthesised by
// public/sounds/nut-tumble.gen.py; regenerate rather than hand-edit.
export function playCompletionSound() {
  try {
    if (!cachedAudio) {
      cachedAudio = new Audio('/sounds/nut-tumble.mp3');
      cachedAudio.volume = 0.4;
    }
    const sound = cachedAudio.cloneNode();
    sound.volume = 0.4;
    sound.play().catch((e) => console.warn('Audio play failed:', e.message));
    setTimeout(() => { sound.pause(); sound.currentTime = 0; }, 1400);
  } catch (e) {
    console.warn('Sound init failed:', e.message);
  }
}
